import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import './SubmitCard.scss';

const SubmitCard = (props) => {
  const {
    title,
    icon: Icon,
    buttonIcon: ButtonIcon,
    onButtonClick,
    buttonTooltip,
    buttonAriaLabel,
    children,
    id,
  } = props;
  const handleClick = () => {
    onButtonClick();
  };
  return (
    <Paper className="grb-submit-card" id={id}>
      <header>
        {Icon && (
          <div className="grb-submit-card-header-icon">
            <Icon />
          </div>
        )}
        <Typography variant="h6" className="grb-submit-card-header-title">{title}</Typography>
        {ButtonIcon && (
          <Tooltip title={buttonTooltip}>
            <Fab color="secondary" aria-label={buttonAriaLabel} size="small" onClick={handleClick}>
              <ButtonIcon />
            </Fab>
          </Tooltip>
        )}
      </header>

      <section className="grb-submit-card-main">
        {children}
      </section>
    </Paper>
  );
};

SubmitCard.propTypes = {
  icon: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({}),
  ]),
  buttonIcon: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({}),
  ]),
  title: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func,
  buttonTooltip: PropTypes.string,
  buttonAriaLabel: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.node.isRequired,
};

SubmitCard.defaultProps = {
  icon: undefined,
  buttonIcon: undefined,
  onButtonClick: undefined,
  buttonTooltip: undefined,
  buttonAriaLabel: undefined,
  id: undefined,
};

export default SubmitCard;
